<template>
  <div>
    <botton-bar/>
    <div class="content">
      <div class="container" style="max-width: 520px">
        <div class="card">
          <div class="card-body">
            <h5 class="font-weight-bold mb-3 text-center">Autenticação</h5>
            <form @submit.prevent="login">
              <div class="form-group mb-3">
                <label class="mb-1 small font-weight-bold">Código de acesso</label>
                <the-mask id="codigo" :mask="['##########', '###########']" class="form-control" type="tel" v-model="phone" placeholder="###########" required/>
              </div>
              <button class="btn btn-primary btn-block" :disabled="loading">
                {{ loading ? 'Entrando...' : 'Entrar' }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {TheMask} from 'vue-the-mask';
  import BottonBar from "@/components/BottonBar";

  export default {
    name: 'Login',
    components: {TheMask, BottonBar},
    data() {
      return {
        phone: '',
        loading: false,
      }
    },

    methods: {
      login() {
        if (this.phone.length < 10) {
          this.$swal('Código invalido!').then(() => {
            this.$helpers.focusElement('codigo');
          });

          return;
        }

        if (!this.regionalId) {
          this.$swal('Regional invalida');
          return;
        }

        this.loading = true;

        this.$http.post(`app/login/${this.regionalId}`, { phone: this.phone })
          .then(response => {
            const dados = response.data && response.data.dados ? response.data.dados : null;

            if (!dados || !dados.token) {
              this.$swal('Erro ao logar');
              this.loading = false;
              return;
            }

            const user = {
              ...this.$store.state.user,
              id_membro: dados.id_membro,
              nome_membro: dados.nome_membro || '',
              token: dados.token,
              id_regional: dados.id_regional || this.regionalId,
              id_setor: dados.id_setor || this.$store.state.user.id_setor || '',
              id_cidade: dados.id_cidade || ''
            };

            this.$store.commit('setDataUser', user);
            this.loading = false;
            this.$router.push('/calendario');

          }, (res) => {
            console.log(res)
            this.$swal(res?.data?.msg || 'Erro ao logar');
            this.loading = false;
          });
      }
    },

    mounted() {
      this.$helpers.focusElement('codigo');
    },

    computed: {
      regionalId() {
        return this.$store.state.id_regional || this.$route.query.regional;
      }
    }
  }
</script>

<style scoped>
</style>
